const FLAGS = [
  {
    icon: "ri-earth-line",
    title: "域名偷偷换字换位",
    desc: "把字母 O 换成数字 0、在官方名后面加 -live、-app、-vip 或调整字母顺序，利用视觉混淆让人误以为是官方域名。",
  },
  {
    icon: "ri-lock-2-line",
    title: "登录页没有安全锁",
    desc: "页面在地址栏显示“不安全”，或根本没有 HTTPS 加密链接。正规平台登录入口一般都会启用加密传输。",
  },
  {
    icon: "ri-file-search-line",
    title: "查不到主体备案",
    desc: "经营性正规站点通常在页脚公示运营主体与备案编号。仿冒站常常删去备案，或只放一张模糊难辨的占位图。",
  },
  {
    icon: "ri-coupon-3-line",
    title: "用充值返利、低价诱导",
    desc: "通过“会员限免”“充一送一”“内部邀请码”等话术催促你付费、填写支付信息，钱一旦转出便很难追回。",
  },
  {
    icon: "ri-user-shared-line",
    title: "过度索取个人隐私",
    desc: "刚打开就要你填身份证、银行卡、手机验证码，甚至要求开启屏幕共享，明显超出正常使用所需的信息范围。",
  },
  {
    icon: "ri-download-2-line",
    title: "要求安装不明客户端",
    desc: "以“网页版不稳定”为由引导下载来历不明的 App 或压缩包，其中很可能捆绑木马、盗号或挖矿程序。",
  },
];

export default function RedFlags() {
  return (
    <section id="signals" className="scroll-mt-20 bg-background-100/60">
      <div className="wrap py-10 md:py-14">
        <div className="max-w-2xl">
          <p className="kicker mb-3">
            <i className="ri-alert-line"></i>
            高危特征速览
          </p>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">进站先看这六处，多数仿冒一眼就露馅</h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            仿冒站大多“形似神不似”，往往只复制了页面外观，却在域名、协议、备案与引导动作上露出马脚。对照下面的高危信号，先给访问的页面做个快速体检。
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FLAGS.map((f) => (
            <article key={f.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-700">
                <i className={f.icon}></i>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{f.desc}</p>
              <p className="mt-3 flex items-start gap-1.5 text-xs text-primary-700">
                <i className="ri-error-warning-line mt-0.5"></i>
                <span>命中越多，越要警惕，先停止填写任何信息。</span>
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}